import { DateHelpers } from '.';

export function formatApptManagerStartDate(convertedTimeZoneDate) {
  const convertedTimeZoneAbbreviation = DateHelpers.filterTimeZoneAbbreviation(convertedTimeZoneDate.format('z'));

  return `${convertedTimeZoneDate.format('MM/DD/YY[\n]hh:mm a')} (${convertedTimeZoneAbbreviation})`;
}

export function formatAppointmentTime(convertedTimeZoneDate, dateFormat = 'ddd, MMM D, YYYY', timeFormat = 'h:mm a') {
  const convertedTimeZoneAbbreviation = DateHelpers.filterTimeZoneAbbreviation(convertedTimeZoneDate.format('z'));

  return `${convertedTimeZoneDate.format(dateFormat)} at ${convertedTimeZoneDate.format(timeFormat)} (${convertedTimeZoneAbbreviation})`;
}
